import {Authorizations, currentUserHasAuthorization} from "utils/authorizations";

/**
 * The quick-create entry of the mapping selects is only offered to members
 * holding the dedicated attribute creation authorization (admin only by
 * default — merchants must not create attribute values).
 */
export default function canQuickCreateAttributes() {
    return currentUserHasAuthorization(Authorizations.MARKETPLACE_ATTRIBUTE_CREATION);
}
